// FORGED Ed Systems — DEPLOY003 — v0.3.0 — IntakeNavigation.tsx
// Last touched: 2026-05-19
//
// Step indicator + back/continue/submit controls for the intake form.

type Props = {
  currentStep: number;        // 1-based
  totalSteps: number;
  isLastStep: boolean;
  isSubmitting: boolean;
  onBack: () => void;
  onContinue: () => void;
  onSubmit: () => void;
};

export default function IntakeNavigation({
  currentStep,
  totalSteps,
  isLastStep,
  isSubmitting,
  onBack,
  onContinue,
  onSubmit,
}: Props) {
  return (
    <div className="intake-nav">
      <div className="intake-step-indicator">
        Step {currentStep} of {totalSteps}
      </div>

      <div className="intake-nav-buttons">
        {currentStep > 1 && (
          <button
            type="button"
            className="cta secondary"
            onClick={onBack}
            disabled={isSubmitting}
          >
            ← Back
          </button>
        )}

        {!isLastStep && (
          <button
            type="button"
            className="cta primary"
            onClick={onContinue}
            disabled={isSubmitting}
          >
            Continue →
          </button>
        )}

        {isLastStep && (
          <button
            type="button"
            className="cta primary"
            onClick={onSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Saving…" : "Save and generate plan"}
          </button>
        )}
      </div>
    </div>
  );
}
